<template>
  <div class="container">
        <div class="wrap">
            <pageHeader/>
            <pageBack/>
            <div class="main">
              <div class="video_bg">
                    <video :src="videoPath" autoplay playsinline loop muted></video>
                  </div>
                <p class="title">身体维度测量</p>
                <div class="dimension d-flex">
                    <div class="video">
                      <!-- <video :src="videoPath" autoplay playsinline></video> -->
                    </div>
                    <div class="detail">
                        <div class="head detail-div">
                          <!-- <div>id:{{id}}</div> -->
                            <div v-for="(item, index) in aiinfo.slice(0, 2)" :key="index">
                                <p>{{item.partName}}</p>
                                <span>{{item.specs}}cm</span>
                            </div>
                        </div>
                        <div class="body detail-div">
                          <div v-for="(item, index) in aiinfo.slice(2, 9)" :key="index">
                                <p>{{item.partName}}</p>
                                <span>{{item.specs}}cm</span>
                            </div>
                        </div>
                        <div class="leg detail-div">
                          <div v-for="(item, index) in aiinfo.slice(9, 13)" :key="index">
                                <p>{{item.partName}}</p>
                                <span>{{item.specs}}cm</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="start-btn" @click="to_link()">
                  <img src="../../assets/index/btn_bg.png" alt="" srcset="">
                  <p>
                    <span>去试衣</span>
                  </p>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getInfo } from '@/api/user';
import { Toast } from 'vant';
export default {
    name:'myDimension',
  data() {
    return {
      id:localStorage.getItem('taskId'),
      aiinfo:[
        {
          partName:'',
          specs:''
        }
      ],
      videoPath:require('@/assets/Dimension.mp4'),
    }
  },
  methods: {
    getInfo(){
      // 78
        getInfo({id:this.id}).then((res) => {
          if (res.code === 1) {
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            this.aiinfo = res.data.aiinfo;
          }else{
            Toast(res.msg)
          }
      });
    },
    to_link(){
      this.$router.push('/selectParts');
    }
  },
  created() {
    // localStorage.setItem('aiData', JSON.stringify(this.data))

  },
  // 例如这个函数就会在组件挂载完成后被调用
  mounted() {
    this.getInfo()
  }
}
</script>
<style src="./index.less" scoped lang="less"></style>